import React from "react";
import {
  Carousel,
  ChatItem,
  Message,
  SourceMessage as SourceMessageType,
} from "../../../types/types";
import {
  CarouselMessage,
  SourceMessage,
  SystemMessage,
  ThoughtMessage,
  UserMessage,
  ReformulationMessage
} from "./Messages/index";

interface ChatItemRendererProps {
  chatItem: ChatItem;
  displaySources: boolean;
  displayCarousel: boolean;
}

const ChatItemRenderer: React.FC<ChatItemRendererProps> = ({
  chatItem,
  displaySources,
  displayCarousel,
}) => {
  switch (chatItem.type) {
    case "user":
      return <UserMessage message={chatItem as Message} />;
    case "source":
      if(displaySources) return <SourceMessage message={chatItem as SourceMessageType} />;
      else return null;
    case "system":
    case "answer":
    case "rag_synthesis":
    case "final_synthesis":
      return <SystemMessage message={chatItem as Message} />;
    case "def":
    case "mq":
    case "thought":
    case "tool":
      return <ThoughtMessage message={chatItem as Message} />;
    case "carousel":
      if (!displayCarousel) return null;
      return (
        <CarouselMessage
          carousel={chatItem as Carousel}
          displaySources={displaySources}
          displayCarousel={displayCarousel}
        />
      );
    case "reformulation":
      console.log("Reformulation message received:", chatItem);
      return <ReformulationMessage message={chatItem as Message} />;
  } 
};

export default ChatItemRenderer;
